import { apiLabs } from '../../api'

const OrderPendding = async (body) => {
	
	const res = await apiLabs.post('recover_sale/pedding', body)
	return res
}

export default OrderPendding